<template>
  <div class="premium-tab-content">
    <div class="premium-card-section mb-4">
      <div class="modal-section-title mb-3">
        <i class="fa fa-globe mr-2 text-primary"></i> Origem e Tributação ICMS
      </div>


      <b-row>
        <b-col md="4">
          <b-form-group label="Origem da Mercadoria" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_ICMS_ORIGEM"
              :options="origemOptions"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group label="CST/CSOSN - Situação Tributária" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_ICMS_SITUACAO_TRIBUTARIA"
              :options="sitTribOptions"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="onSituacaoChange"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Código Benefício Fiscal (cBenef)" label-class="modal-label-premium">
            <b-form-input
              v-model.trim="local.CBENEF"
              maxlength="10"
              class="rounded-pill shadow-xs text-uppercase"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="5">
          <b-form-group label="Motivo Desoneração" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_MOTIVO_DESONERACAO"
              :options="motivosDesoneracaoOptions"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Aliq. Desoneração %" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_ICMS_ALIQUOTA_DESONERA"
              :options="autonumericOptions.percentual"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Deduz Desoneração" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_IND_DEDUZ_DESONERA"
              :options="indDeduzDesoneraOptions"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="premium-card-section bg-soft-primary p-3 rounded-lg border-primary-light mb-4" v-show="camposAtivos.mostrarGrupoICMSNormal">
      <div class="modal-section-title mb-3 text-primary">
        <i class="fa fa-calculator mr-2"></i> ICMS Operação Própria
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="Modalidade BC" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_ICMS_MODAL_DETERM_BC"
              :options="modalidadeBCOptions"
              :disabled="!camposAtivos.OP_ICMS_MODAL_DETERM_BC"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="% Redução BC" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_ICMS_PERCENT_REDUC_BC"
              :options="autonumericOptions.percentual"
              :disabled="!camposAtivos.VL_ICMS_PERCENT_REDUC_BC"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Alíquota %" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_ICMS_ALIQUOTA"
              :options="autonumericOptions.percentual"
              :disabled="!camposAtivos.VL_ICMS_ALIQUOTA"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group label="% BC Operação Própria" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_ICMS_PERC_BC_OPER_PROPRIA"
              :options="autonumericOptions.percentual"
              :disabled="!camposAtivos.VL_ICMS_PERC_BC_OPER_PROPRIA"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-alert v-if="!camposAtivos.mostrarGrupoICMSNormal && local.OP_ICMS_SITUACAO_TRIBUTARIA" show variant="light" class="text-muted small border mb-4">
      Nenhum campo de ICMS próprio aplicável para a situação tributária selecionada.
    </b-alert>

    <div class="premium-card-section bg-soft-warning p-3 rounded-lg border-warning-light" v-show="camposAtivos.mostrarGrupoICMSST">
      <div class="modal-section-title mb-3 text-warning-dark">
        <i class="fa fa-shield mr-2"></i> Substituição Tributária (ICMS ST)
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="Modalidade BC ST" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_ICMS_MODAL_DETERM_BC_ST"
              :options="modalidadeBCSTOptions"
              :disabled="!camposAtivos.OP_ICMS_MODAL_DETERM_BC_ST"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="% Redução BC ST" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_ICMS_PERCENT_REDUC_BC_ST"
              :options="autonumericOptions.percentual"
              :disabled="!camposAtivos.VL_ICMS_PERCENT_REDUC_BC_ST"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="% MVA ST" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_ICMS_MARGEM_VL_ADIC_ST"
              :options="autonumericOptions.percentual"
              :disabled="!camposAtivos.VL_ICMS_MARGEM_VL_ADIC_ST"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group label="Alíquota ST %" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_ICMS_ALIQUOTA_ST"
              :options="autonumericOptions.percentual"
              :disabled="!camposAtivos.VL_ICMS_ALIQUOTA_ST"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-alert v-if="!camposAtivos.mostrarGrupoICMSST && local.OP_ICMS_SITUACAO_TRIBUTARIA" show variant="light" class="text-muted small border mb-0">
      Substituição tributária não aplicável para a situação selecionada.
    </b-alert>
  </div>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'

export default {
  name: 'NfeProdutoIcms',
  components: { VueAutonumeric },
  props: { value: { type: Object, default: () => ({}) } },
  data() {
    return {
      local: {},
      autonumericOptions: {
        percentual: {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalPlaces: 2,
          minimumValue: '0'
        }
      },
      origemOptions: [
        { value: '0', text: '0 - Nacional' },
        { value: '1', text: '1 - Estrangeira - Imp. Direta' },
        { value: '2', text: '2 - Estrangeira - Merc. Interno' },
        { value: '3', text: '3 - Nacional - Conteúdo Imp. > 40%' }
      ],
      sitTribOptions: [
        { value: null, text: 'Selecione...' },
        { value: '00', text: '00 - Tributada Integralmente' },
        { value: '10', text: '10 - Tributada e com cobrança de ICMS por ST' },
        { value: '20', text: '20 - Com redução de Base de Cálculo' },
        { value: '30', text: '30 - Isenta ou não tributada e com cobrança de ICMS por ST' },
        { value: '40', text: '40 - Isenta' },
        { value: '41', text: '41 - Não tributada' },
        { value: '49', text: '49 - Outras (não contribuinte)' },
        { value: '50', text: '50 - Suspensão' },
        { value: '51', text: '51 - Diferimento' },
        { value: '60', text: '60 - ICMS cobrado anteriormente por ST' },
        { value: '70', text: '70 - Com redução de BC e cobrança de ICMS por ST' },
        { value: '90', text: '90 - Outras' }
      ],
      modalidadeBCOptions: [
        { value: '0', text: 'Margem Valor Agregado (%)' },
        { value: '1', text: 'Pauta (Valor)' },
        { value: '2', text: 'Preço Tabelado Máx. (Valor)' },
        { value: '3', text: 'Valor da operação' }
      ],
      modalidadeBCSTOptions: [
        { value: '0', text: 'Preço tabelado ou máximo sugerido' },
        { value: '1', text: 'Lista Negativa (Valor)' },
        { value: '2', text: 'Lista Positiva (Valor)' },
        { value: '3', text: 'Lista Neutra (Valor)' },
        { value: '4', text: 'Margem Valor Agregado (%)' },
        { value: '5', text: 'Pauta (Valor)' }
      ],
      indDeduzDesoneraOptions: [
        { value: null, text: 'Nao informado' },
        { value: '0', text: '0 - Nao deduz' },
        { value: '1', text: '1 - Deduz' }
      ],
      motivosDesoneracaoOptions: [
        { value: null, text: 'Selecione...' },
        { value: '1', text: '1 - Taxi' },
        { value: '2', text: '2 - Deficiente Fisico' },
        { value: '3', text: '3 - Produtor Agropecuario' },
        { value: '4', text: '4 - Frotista/Locadora' },
        { value: '5', text: '5 - Diplomatico/Consular' },
        { value: '6', text: '6 - Amazonia Livre Comercio' },
        { value: '7', text: '7 - SUFRAMA' },
        { value: '8', text: '8 - Venda Orgaos Publicos' },
        { value: '9', text: '9 - Outros' },
        { value: '10', text: '10 - Deficiente Condutor' },
        { value: '11', text: '11 - Deficiente Nao Condutor' },
        { value: '12', text: '12 - Orgao Fomento' },
        { value: '16', text: '16 - Olimpiada Rio 2016' },
        { value: '90', text: '90 - Solicitado Fisco' }
      ]
    }
  },
  computed: {
    camposAtivos() {
      const st = this.local.OP_ICMS_SITUACAO_TRIBUTARIA
      const campos = {
        mostrarGrupoICMSNormal: false,
        mostrarGrupoICMSST: false,
        OP_ICMS_MODAL_DETERM_BC: false,
        VL_ICMS_PERCENT_REDUC_BC: false,
        VL_ICMS_ALIQUOTA: false,
        VL_ICMS_PERC_BC_OPER_PROPRIA: false,
        OP_ICMS_MODAL_DETERM_BC_ST: false,
        VL_ICMS_PERCENT_REDUC_BC_ST: false,
        VL_ICMS_MARGEM_VL_ADIC_ST: false,
        VL_ICMS_ALIQUOTA_ST: false,
        ID_UF_ICMS_ST: false
      }

      switch (st) {
        case '00':
          campos.mostrarGrupoICMSNormal = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break
        case '10':
          campos.mostrarGrupoICMSNormal = true
          campos.mostrarGrupoICMSST = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          campos.OP_ICMS_MODAL_DETERM_BC_ST = true
          campos.VL_ICMS_PERCENT_REDUC_BC_ST = true
          campos.VL_ICMS_MARGEM_VL_ADIC_ST = true
          campos.VL_ICMS_ALIQUOTA_ST = true
          break
        case '20':
          campos.mostrarGrupoICMSNormal = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_PERCENT_REDUC_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break
        case '30':
          campos.mostrarGrupoICMSST = true
          campos.OP_ICMS_MODAL_DETERM_BC_ST = true
          campos.VL_ICMS_PERCENT_REDUC_BC_ST = true
          campos.VL_ICMS_MARGEM_VL_ADIC_ST = true
          campos.VL_ICMS_ALIQUOTA_ST = true
          break
        case '40':
        case '41':
        case '50':
          campos.mostrarGrupoICMSNormal = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break
        case '49':
          campos.mostrarGrupoICMSNormal = true
          break
        case '51':
          campos.mostrarGrupoICMSNormal = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_PERCENT_REDUC_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break
        case '70':
        case '90':
          campos.mostrarGrupoICMSNormal = true
          campos.mostrarGrupoICMSST = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_PERCENT_REDUC_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          campos.OP_ICMS_MODAL_DETERM_BC_ST = true
          campos.VL_ICMS_PERCENT_REDUC_BC_ST = true
          campos.VL_ICMS_MARGEM_VL_ADIC_ST = true
          campos.VL_ICMS_ALIQUOTA_ST = true
          break
      }

      return campos
    }
  },
  watch: {
    value: {
      handler(v) {
        this.local = v || {}
      },
      immediate: true
    }
  },
  methods: {
    onSituacaoChange() {
      const c = this.camposAtivos

      if (!c.OP_ICMS_MODAL_DETERM_BC) this.local.OP_ICMS_MODAL_DETERM_BC = null
      if (!c.VL_ICMS_PERCENT_REDUC_BC) this.local.VL_ICMS_PERCENT_REDUC_BC = 0
      if (!c.VL_ICMS_ALIQUOTA) this.local.VL_ICMS_ALIQUOTA = 0
      if (!c.VL_ICMS_PERC_BC_OPER_PROPRIA) this.local.VL_ICMS_PERC_BC_OPER_PROPRIA = 0
      if (!c.OP_ICMS_MODAL_DETERM_BC_ST) this.local.OP_ICMS_MODAL_DETERM_BC_ST = null
      if (!c.VL_ICMS_PERCENT_REDUC_BC_ST) this.local.VL_ICMS_PERCENT_REDUC_BC_ST = 0
      if (!c.VL_ICMS_MARGEM_VL_ADIC_ST) this.local.VL_ICMS_MARGEM_VL_ADIC_ST = 0
      if (!c.VL_ICMS_ALIQUOTA_ST) this.local.VL_ICMS_ALIQUOTA_ST = 0

      this.emit()
    },
    emit() {
      this.$emit('input', this.local)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeProdutoIcms.vue